/**
 * TanStack Query hooks for `scaling-payouts-volume-breakpoints`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	scalingPayoutsVolumeBreakpointsQueryKeys,
	type CreateScalingPayoutsVolumeBreakpointsBody,
	type ListScalingPayoutsVolumeBreakpointsResponse,
	type ScalingPayoutsVolumeBreakpointsRow,
} from "./api";

export function useScalingPayoutsVolumeBreakpointsList(): UseQueryResult<ListScalingPayoutsVolumeBreakpointsResponse, Error> {
	return useQuery({
		queryKey: scalingPayoutsVolumeBreakpointsQueryKeys.list(),
		queryFn: list,
	});
}

export function useScalingPayoutsVolumeBreakpointsCreate(): UseMutationResult<ScalingPayoutsVolumeBreakpointsRow, Error, CreateScalingPayoutsVolumeBreakpointsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: scalingPayoutsVolumeBreakpointsQueryKeys.all });
		},
	});
}

export function useScalingPayoutsVolumeBreakpointsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: scalingPayoutsVolumeBreakpointsQueryKeys.all });
		},
	});
}
